import { Outlet, RouteObject, useLocation } from 'react-router-dom'

export const savedViewsRoutes: RouteObject[] = [
  {
    path: 'saved-view',
    element: <Outlet />,
    children: [
      {
        path: ':id',
        lazy: async () => {
          const { SavedViewPage } = await import('./pages/SavedViewPage')
          return { Component: SavedViewPage }
        }
      }
    ]
  }
]

export const savedViewPath = (id: string) => `/saved-view/${id}`

export const useIsOnSavedViewPage = () => {
  const { pathname } = useLocation()
  return pathname.startsWith('/saved-view/')
}
